module.exports = __webpack_public_path__ + "static/media/img16_LV.5a4edefd.png";